import { BREAKPOINTS } from '@app/constants/breakpoints';
import { getLookbookProductsGridSize, setLookbookProductsGridSize } from '@app/ducks';
import { useIsScreenSize } from '@app/utils/hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { ContentSwitcher } from '../various/ContentSwitcher';
import { GridLarge, GridMedium, GridSmall } from '../various/Icons';

export const LookbookProductsGridSwitch = () => {
  const { t } = useTranslation(['common']);
  const dispatch = useDispatch();
  const gridSize = useSelector(getLookbookProductsGridSize);

  const isExtraSmallBreakpoint = useIsScreenSize(BREAKPOINTS.XXS);
  const isSmallBreakpoint = useIsScreenSize(BREAKPOINTS.SM);

  React.useEffect(() => {
    if (isExtraSmallBreakpoint && gridSize !== 'large') {
      dispatch(setLookbookProductsGridSize('large'));
    }
    if (isSmallBreakpoint && gridSize === 'small') {
      dispatch(setLookbookProductsGridSize('medium'));
    }
  }, [dispatch, isSmallBreakpoint, gridSize, isExtraSmallBreakpoint]);

  const handleChange = (value: 'small' | 'medium' | 'large') => {
    dispatch(setLookbookProductsGridSize(value));
  };

  const tabs = [
    ...(!isSmallBreakpoint ?
      [
        {
          icon: GridSmall,
          label: 'Small',
          title: t('common:small_grid_view'),
          value: 'small',
        },
      ]
    : []),
    {
      icon: GridMedium,
      label: 'Medium',
      title: t('common:medium_grid_view'),
      value: 'medium',
    },
    {
      icon: GridLarge,
      label: 'Large',
      title: t('common:large_grid_view'),
      value: 'large',
    },
  ];

  return <ContentSwitcher selectedValue={gridSize} groupName="lookbookProductsGridSize" tabs={tabs} onChange={handleChange} />;
};
